import { reactive, ref } from "vue";
import { getNotarialItem, updateNotarial } from "../api";

export function useTransactionItem(uuid) {
  const form = reactive({
    template_code: null,
    state_duty: null,
    number_certified_copies: null,
    status: "PROJECT",
    content: null,
    content_kz: null,
    content_en: null,
    contract_amount: 0,
    languages: [],
    fields: {},
  });

  const loading = ref(false);

  async function fetchTransaction(id) {
    const data = await getNotarialItem(id || uuid.value);
    if (data?.success && data.payload) {
      Object.assign(form, data.payload);
    }
    return data;
  }

  async function updateTransaction(payload, isNotifyDisabled) {
    const data = await updateNotarial(uuid.value, payload, isNotifyDisabled);
    return data;
  }

  return { form, loading, fetchTransaction, updateTransaction };
}
